<template>
  <div style="min-height: 100vh">
    <el-dialog title="Warning" :visible.sync="goBackFullScreenDialog" width="280px" center :show-close="false"
      :close-on-press-escape="false" :close-on-click-modal="false">
      <span style="word-break: break-word;">Please switch back to full screen mode immediately!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="goFullScreen">Switch to Full Screen</el-button>
      </span>
    </el-dialog>
    <div v-if="examEnded == true || interval != null"
      style="position: absolute; width: 100%; height: 100vh; top: 0; left: 0; background-color: rgba(0,0,0,.7); display: flex; align-items: center; justify-content: center; flex-direction: column; z-index: 9999">
      <!-- <h3
        style="font-weight: bold; color: white"
        v-if="examEnded == false && interval != null"
      >{{ 10 - intervalCount }} seconds to continue the exam</h3> -->
      <div v-if="examEnded == true"
        style="display: flex; align-items: center; justify-content: center; flex-direction: column">
        <h3 style="font-weight: bold; color: white; font-size: 30px; margin-bottom: 20px">Your exam has been concluded as
          you exited the exam screen.</h3>
        <el-button @click="end">Finish the Exam</el-button>
      </div>
    </div>
    <div id="interview" :style="examEnded == true || interval != null
      ? 'filter: blur(' +
      (examEnded ? 12 : intervalCount * 1.2) +
      'px) grayscale(' +
      intervalCount / 10 +
      ')'
      : ''
      " style="transition: 1s">
      <div class="top"
        style="display: flex; flex-direction: row; align-items: flex-end; justify-content: center; float: left">
        <div style="
            padding: 0px 20px;
            display: flex;
            width: 170px;height: 120px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 90%;
            background-color: #fff;
            margin-right: 15px
          " :style="'background-image: url(' + $store.state.firm.image + ')'"></div>

        <div style="display: flex; flex: 1; flex-direction: row; box-sizing: border-box; border-left: 2px solid #fff;flex-direction: row;
      align-items: flex-start;
      justify-content: space-between; padding: 0px 15px; color: white;">
          <div style="flex-direction: column; display: flex;">
            <span style="font-weight: 600; font-size: 16px;">
              {{
                $store.state.firm.title
              }}
            </span>
            <span style="font-weight: 400; font-size: 16px;">
              {{
                $store.state.department.title
              }}
            </span>
            <span style="font-weight: 400; font-size: 14px;">
              <span class="primary-text">
                <i class="el-icon-user-solid"></i> Welcome,
              </span>
              {{ $store.state.form.firstName }} {{ $store.state.form.lastName }}.
            </span>
          </div>
          <Timer :notifyme="30" @notifyYou="notifyTrigger" :deadline="deadline" @timerEnded="timerEnded"
            v-if="deadline != null && $store.state.currentSection != 5 && dialogVisible == false" />
        </div>
        <div style="height: 120px;">
          <video id="video" width="180" height="120" autoplay></video>
        </div>
      </div>

      <div class="content">
        <div id="steps" v-if="$store.state.exam.type != 2 && $store.state.exam.type != 3">
          <div class="step" :class="i <= $store.state.currentSection + 1 ? 'active' : null" v-for="i in 5" :key="i">
            <div class="step-title">{{ i == 5 && $store.state.exam.type == 1 ? 'FINISH' : sectionTypes.find(k => k.id ==
              i).title }}</div>
            <div class="step-arrow" v-if="i == $store.state.currentSection + 1 && i != 5"></div>
            <div class="step-arrow-chevron" v-if="i != $store.state.currentSection + 1 && i != 5">
              <div class="chevron right"></div>
            </div>
          </div>
        </div>

        <div class="part1" v-if="$store.state.currentSection < 5">
          <template v-for="(item, index) in $store.state.section.questions
            .skip(filter.skip)
            .take(filter.take)">
            <!-- coktan secmeli -->
            <div :key="filter.skip + index" class="test-question" v-if="item.type == 1" @click.right.prevent
              @keydown="keydown" @copy.prevent @paste.prevent>
              <div class="q-num">{{ filter.skip + index + 1 }}.</div>
              <h4 style="margin-top: 7px;">{{ item.title }}</h4>
              <el-radio-group v-model="$store.state.section.questions[filter.skip + index].isSelected
                ">
                <el-radio @change="radioChanged($event, filter.skip + index, answerIndex)" :label="answer" v-for="(answer, answerIndex) in item.answers" :key="answerIndex">{{ answer.answer }}</el-radio>
              </el-radio-group>
            </div>
            <!-- coktan secmeli -->

            <!-- bosluk doldurma -->
            <div :key="filter.skip + index" class="test-question inline-block type-3" v-if="item.type == 3">
              <span v-for="(item, i) in $store.state.section.questions[
                filter.skip + index
              ].title.replace(/\u00a0/g, ' ').split(' ')" :key="i"
                :style="item.indexOf('%cevap%') != -1 ? 'line-height: 20px' : ''">
                <el-popover placement="top" v-model="$store.state.section.questions[
                  filter.skip + index
                ].visible" v-if="item.indexOf('%cevap%') != -1">
                  <div style="display: flex; flex-direction: row">
                    <span @click="popupChanged(a.id, filter.skip + index)" class="select-item" :key="indexx" v-for="(a, indexx) in $store.state.section.questions[
                      filter.skip + index
                    ].answers">{{ a.answer }}</span>
                  </div>
                  <el-button type="select-button" slot="reference">
                    {{ $store.state.section.questions[
                      filter.skip + index
                    ].answers.filter((k) => k.isSelected).length == 0 ?
                      '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : $store.state.section.questions[
                        filter.skip + index
                      ].answers.find((k) => k.isSelected).answer }}
                  </el-button>
                </el-popover>
                <span v-else style="margin-right: 5px;">{{ item }}</span>
              </span>
            </div>
            <!-- bosluk doldurma -->

            <!-- translate -->
            <div :key="filter.skip + index" class="test-question" v-if="item.type == 5" @paste.prevent @copy.prevent
              @click.right.prevent @cut.prevent>
              <div>
                <div class="q-num">{{ filter.skip + index + 1 }}.</div>
                <h4>{{ item.title }}</h4>
                <el-input style="margin-top: 5px;" type="textarea" v-model="$store.state.section.questions[filter.skip + index].answer
                  " placeholder="Write your answer here"></el-input>
              </div>
            </div>
            <!-- translate -->

            <!-- listening -->
            <div :key="filter.skip + index" class="test-question" v-if="item.type == 2">
              <div>
                <div class="q-num">{{ filter.skip + index + 1 }}.</div>
                <div style="display: block; margin-bottom: 15px" v-if="index == 0">
                  <Player @played="isPlayed = true; mustlisten = false" :mustlisten="mustlisten" :url="$store.state.section.questions[filter.skip + index].filePath" />
                </div>
                <h4>{{ item.title }}</h4>
                <div style="position: relative">
                  <el-radio-group v-model="$store.state.section.questions[filter.skip + index].selected">
                    <el-radio @change="radioChanged($event, filter.skip + index, answerIndex)" :label="answer.answer" v-for="(answer, answerIndex) in item.answers" :key="answerIndex">{{answer.answer }}</el-radio>
                  </el-radio-group>
                  <div v-if="mustlisten" class="overlay">Please listen to the audio to see the questions.</div>
                </div>
              </div>
            </div>
            <!-- listening -->

            <!-- mail cevaplama -->
            <div :key="filter.skip + index" class="test-question" v-if="item.type == 4" @paste.prevent @copy.prevent
              @click.right.prevent @cut.prevent>
              <div style="display: flex; flex-direction: row; align-items: center">
                <img src="https://picsum.photos/300/300"
                  style="width: 50px; height: 50px; border-radius: 50%; margin-right: 10px" />
                <div style="display: flex; flex-direction: column; font-size: 15px; justify-content: center">
                  <span style="line-height: 16px">
                    <span style="color: gray">From:</span> johndoe@example.com
                  </span>
                  <span style="line-height: 16px">
                    <span style="color: gray">To:</span> john@internative.net
                  </span>
                  <span style="line-height: 16px">
                    <span style="color: gray">Subject:</span> A problem to be solved
                  </span>
                </div>
              </div>
              <div>
                <p style="font-size: 15px; color: #333; line-height: 17px" v-html="item.title"></p>
              </div>

              <div style="position: relative;">
                <textarea style="width: 100%;" type="textarea" placeholder="Please Answer" v-model="$store.state.section.questions[filter.skip + index].answer
                  " @keydown="inputChanged" class="el-textarea__inner" rows="10"></textarea>
                <div style="width: 100%; text-align: right;">{{ wordCount }}/120</div>
              </div>
            </div>
            <!-- mail cevaplama -->
          </template>

          <div
            style="display: flex; width: 100%;flex-direction: row; justify-content: space-between; align-items: center; margin-top: 20px;">
            <el-button type="danger" style=" float: left" @click="finishNowDialog = true">Finish the Exam</el-button>
            <h3 style="margin: 0; color: gray">{{ filter.skip }}/{{ $store.state.section.questions.length }}</h3>
            <el-button type="warning" style=" float: right" @click="checkStep">{{ $store.state.exam.type != 1 ? 'Next' :
              ($store.state.currentSection == 4 ? 'Finish' : 'Next') }}</el-button>
          </div>
        </div>
        <!-- listening -->

        <div class="part1" v-if="$store.state.currentSection == 5" style="padding: 50px 0px">
          <h3 v-if="$store.state.exam.type != 1 && $store.state.exam.type != 4">BOOK A SPEAKING EXAM</h3>
          <p v-if="$store.state.exam.type != 1 && $store.state.exam.type != 4" style="font-size: 16px; line-height: 1.4">
            You will be called at the exact date and time booked, make your appointment accordingly please.
            <br />The speaking exam lasts approximately 20 minutes depending on your English speaking level.
            <br />Always remember that speaking exams are recorded in case the company you have applied for demands.
            <br />You are advised to prepare your headphones if you feel more comfortable while speaking.
          </p>
          <el-switch v-if="$store.state.exam.type != 1 && $store.state.exam.type != 4" v-model="instantAppointment" active-text="Instant Appointment"
            inactive-text="Planned Appointment"></el-switch>

          <div v-if="$store.state.exam.type != 1 && $store.state.exam.type != 4" style="display: flex; flex-direction: row; align-items: center; justify-content: center; margin-top: 15px">
            <el-date-picker :disabled="instantAppointment" v-model="appointmentDate" format="dd/MM/yyyy"
              value-format="yyyy-MM-dd" type="date" style="flex: 1" placeholder="Pick a date"></el-date-picker>
            <el-select :disabled="instantAppointment" v-model="hour" placeholder="Pick a time"
              style="width: 300px; margin-left: 10px">
              <el-option v-for="item in availableHours" :key="item.date" :disabled="item.isAvailable == false"
                :label="moment(item.date).format('HH:mm')" :value="moment(item.date).format('HH:mm')">
                <span style="float: left">{{ moment(item.date).format('HH:mm') }}</span>
                <span :style="'color: ' + (item.isAvailable ? 'green' : 'red')"
                  style="float: right; color: #8492a6; font-size: 13px">{{ item.isAvailable ? 'Available' : 'NotAvailable'
                  }}</span>
              </el-option>
            </el-select>
          </div>
          <div
            style="background: #fff; padding: 10px 15px; margin-top: 15px; display: flex; flex-direction: row; align-items: center; justify-content: space-between; border-radius: 5px">
            <el-checkbox v-model="form.kvkk">I have read the nondisclosure text and I accept</el-checkbox>
            <el-button size="mini" @click="kvkkModal = true">Click to read</el-button>
          </div>
          <el-button type="success" style="margin-top: 20px; float: left" @click="complete()"
            :loading="finishLoading">Confirm and Finish the Exam</el-button>
        </div>
      </div>

      <el-dialog :visible="dialogVisible" custom-class="info-modal" width="600px">
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
          <h1 class="secondary-text">{{ sectionEnums.find((k) => k.id == $store.state.section.type).title }}</h1>
          <div style="font-weight: bold;
    color: black;
    line-height: 24px;">
            <p v-html="$store.state.nextSectionMessage"></p>
          </div>

          <el-button type="success" round @click="dialogVisible = false;">I understand. Continue</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible="finishDialog" custom-class="info-modal" width="600px">
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
          <h1 class="secondary-text">IM exam has been completed</h1>
          <p style="text-align: center"></p>

          <el-button type="success" round @click="end">Close</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="finishNowDialog" width="500px" title="FINISH THE EXAM">
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: row; flex-wrap: wrap">
          <div v-for="(item, index) in getExamStatus" :key="index"
            style="display: flex; flex-direction: column; align-items: center; width: calc(50% - 44px); padding: 10px; border:1px solid #ddd; margin: 10px">
            <h3 style="word-break: break-word; text-align: center">{{ item.title }}</h3>
            <div style="font-size: 60px">
              <i class="el-icon-error" style="color: red" v-if="item.count != item.completed"></i>
              <i class="el-icon-success" style="color: green" v-if="item.count == item.completed"></i>
            </div>
            <span>{{ item.completed }}/{{ item.count }}</span>
          </div>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
          <p>Are you sure you want to end the exam?</p>
          <div
            style="background: #fff; padding: 10px 15px; margin-top: 15px; display: flex; flex-direction: column; align-items: center; justify-content: space-between; border-radius: 5px">
            <el-checkbox v-model="form.kvkk">I have read the nondisclosure text and I accept</el-checkbox>
            <el-button style="margin-top: 10px;" size="mini" @click="kvkkModal = true">Click to read</el-button>
          </div>
          <el-button type="danger" @click="finishInstant">End the exam</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible="kvkkModal" custom-class="info-modal" width="600px">
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
          <div v-html="kvkk" style="width: 100%;word-break: break-word;"></div>
          <div
            style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
            <el-button round @click="kvkkModal = false; form.kvkk = false">Close</el-button>
            <el-button type="success" round @click="kvkkModal = false; form.kvkk = true">I understand. Accept</el-button>
          </div>
        </div>
      </el-dialog>

      <el-dialog :visible="kvkkModal2" custom-class="info-modal" width="600px">
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
          <div v-html="kvkk" style="width: 100%;word-break: break-word;"></div>
          <div
            style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
            <el-button round @click="kvkkModal2 = false; form.kvkk = false">Close</el-button>
            <el-button type="success" round @click="kvkkModal2 = false; complete()">I understand. Accept &
              Finish</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "jquery-ui";
import "jquery-ui/ui/widgets/draggable";
import axios from "axios";
import Player from "@/components/player.vue";
import Timer from "@/components/Timer.vue";
import moment from "moment";

export default {
  name: "Interview",
  components: {
    Player,
    Timer,
  },
  data() {
    return {
      reason: null,
      hour: null,
      availableHours: [],
      moment,
      kvkkModal2: false,
      finishNowDialog: false,
      mustlisten: false,
      dialogVisible: false,
      filter: {
        skip: 0,
        take: 3,
      },
      form: {
        kvkk: false,
      },
      instantAppointment: false,
      appointmentDate: null,
      intervalCount: 0,
      interval: null,
      interval2: null,
      interval3: null,
      examEnded: false,
      nextLoading: false,
      finishDialog: false,
      sectionTypes: [
        {
          id: 1,
          title: "USE OF ENGLISH",
        },
        {
          id: 2,
          title: "LISTENING",
        },
        {
          id: 3,
          title: "CLOZE TEST",
        },
        {
          id: 4,
          title: "CASE STUDY & TRANSLATION",
        },
        {
          id: 5,
          title: "SPEAKING",
        },
      ],
      sectionEnums: [
        {
          id: 1,
          title: "USE OF ENGLISH",
        },
        {
          id: 2,
          title: "LISTENING",
        },
        {
          id: 3,
          title: "CLOZE TEST",
        },
        {
          id: 4,
          title: "CASE STUDY",
        },
        {
          id: 5,
          title: "TRANSLATION",
        },
        {
          id: 10,
          title: "SPEAKING",
        },
      ],
      remainingTime: 0,
      remainingInterval: null,
      hideQuestions: false,
      isPlayed: false,
      deadline: null,
      finishLoading: false,
      kvkk: null,
      kvkkModal: false,
      wordCount: 0,
      screenShot: null,
      goBackFullScreenDialog: false,
    };
  },
  mounted() {
    axios
      .get(
        "https://ingilizcemulakat.com/tr/sozlesme/kvkk-aydinlatma-metni?popup=1"
      )
      .then((res) => {
        this.kvkk = res.data;
      });
    this.setDeadline(this.$store.state.section.duration);

    //TODO geri açılacak yalım
    this.goFullScreen()


    document.addEventListener('fullscreenchange', this.warnFullScreen);
    document.addEventListener('mozfullscreenchange', this.warnFullScreen);
    document.addEventListener('webkitfullscreenchange', this.warnFullScreen);
    document.addEventListener('msfullscreenchange', this.warnFullScreen);


    //TODO geri açılacak yalım
     window.onfocus = () => {
      if(this.$store.state.currentSection == 5){
            return;
          }
       this.intervalCount = 0;
       clearInterval(this.interval);
       this.interval = null;
     };
     window.onblur = () => {
      if(this.$store.state.currentSection == 5){
            return;
          }
       if (this.examEnded == false) {
         this.startInterval();
       }
     };

    this.videoEl = document.getElementById("video");
    this.canvas = document.getElementById("canvas");

    if (this.$store.state.exam.type == 2) {
      return;
    }

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
        
        this.videoEl.srcObject = stream;
        this.videoEl.play();
        this.$store.state.isRecording = true;
        $(".draggable").draggable({ containment: "#app" });

        this.interval2 = setInterval(() => {
          var context = this.canvas.getContext("2d");
          context.drawImage(this.videoEl, 0, 0, 240, 180);

          var b64Image = canvas.toDataURL("image/jpeg");
          var u8Image = this.b64ToUint8Array(b64Image);

          var formData = new FormData();
          formData.append("image", new Blob([u8Image], { type: "image/jpg" }));

          axios
            .post(
              "exam/uploadfile?accesskey=" + this.$store.state.key,
              formData
            )
            .then((res) => { });
        }, 5000);
      });
    }

    this.interval3 = setInterval(() => {
      this.screenCapture();

      if (this.screenShot) {
        const formData = new FormData();
        formData.append("image", new Blob([this.screenShot], { type: "image/jpg" }));

        axios
          .post(
            "exam/uploadfile?accesskey=" + this.$store.state.key,
            formData,
          )
          .then((res) => {
            if (!res.data.hasError) this.screenShot = null;
          })
      }
    }, 5000);
  },
  methods: {
    keydown: function (e) {
      console.log(e);
    },

    inputChanged($event) {
      if (
        ($event.target.value.match(/([\s])+/g) || []).length == 120 &&
        $event.code != "Backspace"
      ) {
        event.preventDefault();
      }
      this.wordCount = ($event.target.value.match(/([\s])+/g) || []).length;
      return $event;
    },
    openURL(url) {
      window.open(url);
    },
    async finishInstant() {
      await this.saveSection(true);
      this.complete(true);
    },
    timerEnded() {
      this.reason = "Bu sınavda herhangi bölümde süre bitmiş olabilir.";
      if (this.$store.state.exam.type == 3) {
        this.form.kvkk = true;
        this.finishInstant();
        return;
      }
      if (
        this.$store.state.section.type != 2 ||
        this.filter.skip + this.filter.take ==
        this.$store.state.section.questions.length
      ) {
        this.dialogVisible = true;
      }

      if (this.$store.state.section.type == 2) {
        this.nextStep1();
      } else {
        this.nextStep1(true);
      }
    },
    notifyTrigger() {
      if (this.isPlayed == false && this.$store.state.section["type"] == 2) {
        this.mustlisten = true;
      }
    },
    setDeadline(minutes) {
      this.deadline = moment()
        .add({ minutes: Math.floor(minutes) })
        .format("YYYY-MM-DD HH:mm:ss");
    },
    b64ToUint8Array(b64Image) {
      var img = atob(b64Image.split(",")[1]);
      var img_buffer = [];
      var i = 0;
      while (i < img.length) {
        img_buffer.push(img.charCodeAt(i));
        i++;
      }
      return new Uint8Array(img_buffer);
    },
    checkStep() {
      var count = this.$store.state.section.questions
        .skip(this.filter.skip)
        .take(this.filter.take)
        .filter(
          (item) =>
            item.answer == null &&
            item.answers.findIndex((k) => k.isSelected == true) == -1
        ).length;

      if (count != 0) {
        this.$message.error("Please answer all the questions.");
        return;
      }

      if (
        this.$store.state.section.questions.length ==
        this.filter.skip + this.filter.take ||
        this.$store.state.section.questions.length <
        this.filter.skip + this.filter.take
      ) {
        this.saveSection();
      } else {
        if (
          (this.$store.state.exam.type == 2 ||
            this.$store.state.exam.type == 3) &&
          (this.$store.state.currentSection == 4 ||
            this.$store.state.currentSection == 1)
        ) {
          this.nextStep1(true);
          return;
        }
        this.nextStep1();
      }
    },
    async saveSection(instant) {
      await axios
        .post("exam/savesection?accesskey=" + this.$store.state.key, {
          section: this.$store.state.section,
        })
        .then((res) => {
          if (instant == true) {
            return;
          }
          this.nextLoading = false;
          if (
            res.data.hasError == false &&
            res.data.data.isCompleted == false
          ) {
            this.$store.state.nextSectionMessage =
              res.data.data.nextSectionMessage;
            this.$store.commit("setSection", res.data.data.section);
            this.$store.state.currentSection += 1;
            this.filter = {
              skip: 0,
              take:
                res.data.data.section.type == 2
                  ? 5
                  : res.data.data.section.type == 3
                    ? 100
                    : 3,
            };

            this.dialogVisible = true;

            if (res.data.data.section.type == 2) {
              this.setDeadline(res.data.data.section.duration / 2);
            } else {
              this.setDeadline(res.data.data.section.duration);
            }
          } else {
            if (
              (this.$store.state.exam.type == 1 &&
                this.$store.state.currentSection == 4) ||
              this.$store.state.exam.type == 3
            ) {
              if (this.$store.state.exam.type == 3) {
                this.form.kvkk = true;
                this.kvkkModal2 = true;
              } else {
                this.complete();
              }

              return;
            }
            this.$store.state.currentSection = 5;
          }
        });
    },
    nextStep1(force) {
      this.isPlayed = false;
      this.hideQuestions = false;
      this.nextLoading = true;
      this.dialogVisible = false;
      if (
        this.$store.state.section.questions.length ==
        this.filter.skip + this.filter.take ||
        this.$store.state.section.questions.length <
        this.filter.skip + this.filter.take ||
        force == true
      ) {
        this.saveSection();
      } else {
        var x = this.$store.state.section.questions.reduce(function (a, b) {
          return a.duration + b;
        });

        if (this.$store.state.section.type == 2) {
          this.setDeadline(this.$store.state.section.duration / 2);
        }

        this.nextLoading = false;
        this.filter = {
          skip: this.filter.skip + this.filter.take,
          take: this.filter.take,
        };
      }
    },
    radioChanged($event, questionIndex, answerIndex) {
      this.$store.state.section.questions[questionIndex].answers.map(
        (item, index) => {
          this.$store.state.section.questions[questionIndex].answers[
            index
          ].isSelected = false;
        }
      );
      this.$store.state.section.questions[questionIndex].answers[
        answerIndex
      ].isSelected = true;
    },
    selectChanged(val, index) {
      var answerIndex = this.$store.state.section.questions[
        index
      ].answers.findIndex((k) => k.id == val.target.value);
      if (answerIndex != -1) {
        this.$store.state.section.questions[index].answers.map(
          (item, indexx) => {
            this.$store.state.section.questions[index].answers[
              indexx
            ].isSelected = false;
          }
        );
        this.$store.state.section.questions[index].answers[
          answerIndex
        ].isSelected = true;
      }
    },
    popupChanged(val, index) {
      this.$store.state.section.questions[index].visible = false;
      var answerIndex = this.$store.state.section.questions[
        index
      ].answers.findIndex((k) => k.id == val);
      if (answerIndex != -1) {
        this.$store.state.section.questions[index].answers.map(
          (item, indexx) => {
            this.$store.state.section.questions[index].answers[
              indexx
            ].isSelected = false;
          }
        );
        this.$store.state.section.questions[index].answers[
          answerIndex
        ].isSelected = true;
      }
    },
    startInterval() {
      this.interval = setInterval(() => {
        this.intervalCount += 1;
        if (this.intervalCount == 1) {
          //TODO: test için kaldırıldı açılacak - YALIM
          if(this.$store.state.currentSection != 5){
            this.examEnded = true;
           this.reason = "Kullanıcı başka bir yere focus olduğu için sınav sonlandırıldı.";
           this.form.kvkk = true;
           this.finishInstant();
           clearInterval(this.interval);
           this.interval = null;
           this.intervalCount = 0;
          }
  
        }
      }, 500);
    },
    end() {
      this.$router.push({ name: "start" });
      window.location.reload();
    },
    complete(instantFinish) {
      if (instantFinish == undefined) {
        instantFinish = false;
      }
      if (this.form.kvkk == false) {
        this.$message.error("please read the nondisclosure text and accept");
        return;
      }

      this.finishLoading = true;

      axios
        .post("exam/finishExam?accesskey=" + this.$store.state.key, {
          instant: instantFinish,
          reason: this.reason,
          appointmentDate:
            this.appointmentDate == "" || this.appointmentDate == null
              ? moment().format("YYYY-MM-DD")
              : this.appointmentDate +
              "T" +
              (this.hour == null || this.hour == "" ? "00:00" : this.hour) +
              ":00Z",
          instantAppointment: this.instantAppointment,
        })
        .then((res) => {
          this.finishLoading = false;
          if (res.data.hasError) {
            this.$message.error(res.data.message);
          } else {
            this.finishDialog = true;
          }
        });
    },
    screenCapture() {
      
      const captureElement = document.querySelector('body')
      html2canvas(captureElement)
        .then(canvas => {
          canvas.style.display = 'none'
          document.body.appendChild(canvas)
          return canvas
        })
        .then(canvas => {
          const image = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')
          const u8Image = this.b64ToUint8Array(image);

          this.screenShot = u8Image
          canvas.remove()
        })
    },
    async goFullScreen() {
       const element = document.documentElement;
       try {
         if (element.requestFullscreen) {
           await element.requestFullscreen();
         } else if (element.mozRequestFullScreen) {
           await element.mozRequestFullScreen();
         } else if (element.webkitRequestFullscreen) {
           await element.webkitRequestFullscreen();
         } else if (element.msRequestFullscreen) {
           await element.msRequestFullscreen();
         }

         if (document.fullscreenElement) {
           this.goBackFullScreenDialog = false;
         }
          console.log('Full screen entered');
       } catch (error) {
       console.error('Failed to enter full screen:', error);
       }
    },
    warnFullScreen() {
      if ((!document.fullscreenElement) && this.examEnded == false) {
        if(this.$store.state.currentSection != 5){
        this.goBackFullScreenDialog = true;
      }
      }
    },
  },
  computed: {
    getExamStatus() {
      
      if (
        this.$store.state.section == null ||
        this.$store.state.exam.type == 2
      ) {
        return [];
      }

      var sections = [];

      this.$store.state.sectionInfos.map((sectionInfo) => {
        if (
          this.$store.state.sectionHistory.findIndex(
            (k) => k.id == sectionInfo.id
          ) != -1
        ) {
          var hSection = this.$store.state.sectionHistory.find(
            (k) => k.id == sectionInfo.id
          );

          sections.push({
            count: hSection.questions.length,
            completed: hSection.questions.filter((k) =>
              k.answers.some((y) => y.isSelected)
            ).length,
            title: this.sectionEnums.find((k) => k.id == hSection.type).title,
            type: sectionInfo.type,
          });
        } else if (this.$store.state.section.id == sectionInfo.id) {
          var hSection = this.$store.state.section;

          sections.push({
            count: hSection.questions.length,
            completed: hSection.questions.filter((k) =>
              k.answers.some((y) => y.isSelected)
            ).length,
            title: this.sectionEnums.find((k) => k.id == hSection.type).title,
            type: sectionInfo.type,
          });
        } else {
          sections.push({
            count: sectionInfo.questions.length,
            completed: 0,
            title: this.sectionEnums.find((k) => k.id == sectionInfo.type)
              .title,
            type: sectionInfo.type,
          });
        }
      });

      if (this.$store.state.exam.type == 3) {
        sections.splice(3, 1);
        sections.splice(2, 1);
        sections.splice(1, 1);
        return sections;
      }
    
      if (this.$store.state.exam.type == 4 || this.$store.state.exam.type == 5) {
        this.$store.state.currentSection = 2;
        return sections;
      }

      sections[3].title = "TRANSLATION & CASE STUDY";
      sections[3].completed = sections[3].completed + sections[4].completed;

      sections.splice(4, 1);
      sections.splice(4, 1);

      if (this.$store.state.exam.type == 3) {
        sections.splice(3, 1);
        sections.splice(2, 1);
        sections.splice(1, 1);
      }

      return sections;
    },
  },
  watch: {
    "form.kvkk": function (newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.kvkkModal = true;
      }
    },
    appointmentDate: function () {
      axios
        .post("exam/getavailabledays", { date: this.appointmentDate })
        .then((res) => {
          var data = [];
          res.data.data.times.map((item) => {
            var m = moment(item.date);
            if (m.isBefore(moment().add(5, "minutes")) == false) {
              data.push(item);
            }
          });
          this.availableHours = data;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Interview.vue